<template>
  <b-button
    class="d-flex justify-content-center align-items-center btn-style position-relative"
    :variant="'transparent'"
    :to="to"
  >
    <img
      :src="require('@/assets/images/theme2/DWCardBackground.svg')"
      alt="Background"
      class="background-image"
    >
    <div class="content-overlay-td">
      <h4 class="">
        {{ $t(titleKey) }}
      </h4>
      <span v-if="subtitleKey">{{ '(' + $t(subtitleKey) + ')' }}</span>
    </div>
  </b-button>
</template>

<script>
export default {
  name: 'DepositButton',
  props: {
    variant: {
      type: String,
      default: 'success',
    },
    to: {
      type: String,
      required: true,
    },
    titleKey: {
      type: String,
      required: true,
    },
    subtitleKey: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.btn-style {
  overflow: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.content-overlay-td {
  position: relative;
  z-index: 2;
}
</style>
